import { Box, Heading, Text, chakra } from '@chakra-ui/react';
import { format } from 'date-fns';

type Props = {
  firstName?: string;
};

export default function WelcomeHeader({ firstName }: Props) {
  const dateLabel = format(new Date(), 'EEEE, MMMM d');
  const name = firstName?.trim() || 'there';

  return (
    <Box mt={3} mb={5}>
      <Text textStyle='eyebrow' mb={2}>
        {dateLabel}
      </Text>
      <Heading
        as='h1'
        textStyle='display'
        fontSize={{ base: 'h2', md: 'h1' }}
      >
        Welcome,{' '}
        <chakra.em color='brand.fg' fontStyle='italic'>
          {name}.
        </chakra.em>
      </Heading>
      <Text fontSize='ui' color='fg.muted' mt={2}>
        Pick up where you left off — or start something new.
      </Text>
    </Box>
  );
}
